import { Component, OnInit, Input } from '@angular/core';
import { dialogConfig } from '@modals/dialog.configure';
import { MbDialog, MbAlertModule } from '@am/moebius';
import { ModalAccommodationFeeComponent } from '@modals/acommodation-fee/accommodation-fee.component';

@Component({
    selector: 'accommodation-fee',
    templateUrl: './accommodation-fee.component.html',
    styleUrls: ['./accommodation-fee.component.scss'],
    standalone: true,
    imports: [MbAlertModule],
})
export class AccommodationFeeComponent implements OnInit {
  @Input()
  accommodationFee: any;

  constructor(private dialog: MbDialog) {}

  ngOnInit() {}

  public toggleModal() {
    if (!this.dialog.isAnyDialogOpen) {
      const dialogData = { accommodationFee: this.accommodationFee };
      this.dialog.open(ModalAccommodationFeeComponent, {
        ...dialogConfig,
        dialogData: dialogData,
        closeBtn: true,
      });
    }
  }
}
